export enum HealthStatus {
  Inactive = 'INACTIVE',
  Healthy = 'HEALTHY',
  Attention = 'ATTENTION',
  Repayment = 'REPAYMENT_NOTICE',
  Default = 'DEFAULT_NOTICE',
}

export type HealthConfig = {
  status: HealthStatus;
  statusTitle?: string;
  pathFillColor: string;
  textColor: 'success' | 'info' | 'warning' | 'error' | 'secondary';
  chipColor?: 'success' | 'info' | 'warning' | 'destructive';
  chipText?: string;
};

export type LoanSummaryData = {
  percentage: number;
  btcPriceSecurityValue: string;
  lvrTitle: string;
  lvrDescription: string;
  lvr: string;
  cardSeverity: 'info' | 'warning' | 'destructive' | 'success';
};
